import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Heading,
  IconButton
} from '@walmart-web/livingdesign-components';
import { Close as CloseIcon } from '@livingdesign/icons';

import NotificationsPanelBody from '../NotificationsPanelBody/index.tsx';
import styles from './styles.module.css';

type Props = {
  onClose: () => void;
};

const NotificationsPanel: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation('profile');

  return (
    <Grid UNSAFE_className={styles.notificationsPanel}>
      <Grid UNSAFE_className={styles.notificationsPanelHeader}>
        <Heading size="small" UNSAFE_className={styles.panelTitle}>
          {t('notifications.title')}
        </Heading>
        <IconButton a11yLabel="close notifications button" onClick={onClose}>
          <CloseIcon size="medium" />
        </IconButton>
      </Grid>

      <NotificationsPanelBody onClose={onClose} />
    </Grid>
  );
};

export default NotificationsPanel;
